import React from 'react';
import './ButtonEmail.css';

const ButtonEmail =(props) => {
    return (
       <a className="button-email" href='mailto:jozefdeville@yahoo.com' target="_blank">
       <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57.1 38.34"><g id="a70d06a5-1f5d-406f-a90c-452d932526d1" data-name="Layer 2"><g id="ba2f8f5b-483b-47f9-b7a5-5269ae7aab3e" data-name="Layer 5"><polygon points="0 0 57.1 0 28.55 20.94 0 0" fill="#fff"/><polygon points="57.1 38.34 57.1 5.17 28.55 26.38 0 5.49 0 38.34 57.1 38.34" fill="#fff"/></g></g></svg>
       </a>
    )
};

export default ButtonEmail;

